import { apiSlice } from 'app/api/apiSlice'
import { removeEmptyKeys } from 'utilities'

export const functionApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getFunctions: builder.query({
            query: ({ page, limitNumber, params }) => {
                return {
                    url: `/bouser/admin/functions/${page}/params`,
                    params: { limitNumber, ...removeEmptyKeys(params) },
                }
            },
            transformResponse: (response, meta, args) => {
                let parsedSGE = response.functions.map((functions) => {
                    return {
                        ...functions
                    }
                })
                return {
                    rows: parsedSGE,
                    // count: response.count,
                    // pages: response.pages,
                }
            },
            providesTags: ['functions'],
        }),
        toggleFunctionAble: builder.mutation({
            query: ({ id }) => {
                return {
                    url: `/bouser/admin/functions/able`,
                    method: 'PUT',
                    body: { id },
                }
            },
            invalidatesTags: ['functions'],
        }),
    }),
    overrideExisting: true,
})

export const {
    useGetFunctionsQuery,
    useToggleFunctionAbleMutation,
} = functionApiSlice
